export default __webpack_public_path__ + "static/media/logo_valleybeach_black.0ffa123e.png";